import { withManagedProps } from "@made-people/managed-props";
import { CentraSearchResultsProviderProps } from "@made-people/grease-centra";
import { ProductTemplateAsSalzburgProps } from "@made-people/blueprint-product";
import { QuickShopWithSiblings } from "./QuickShopWithSiblings";
import { QuickShopProductSwitcher } from "./QuickShopProductSwitcher";

export const ProductQuickshop = withManagedProps(
  "ProductQuickshop",
  (
    props: CentraSearchResultsProviderProps & {
      heading?: string;
      description?: string;
      variants?: ProductTemplateAsSalzburgProps["variants"];
    },
  ) => {
    const productsPayload = props.payload.products;
    let productIds: string[] = [];
    if (productsPayload && typeof productsPayload === "string") {
      productIds = (productsPayload as string).split(",");
    } else if (Array.isArray(productsPayload)) {
      productIds = productsPayload as string[];
    }

    return (
      <QuickShopWithSiblings productIds={productIds}>
        {(products, baseProductId) => (
          <QuickShopProductSwitcher
            products={products}
            baseProductId={baseProductId}
            heading={props?.heading}
            description={props?.description}
            variants={props.variants}
          />
        )}
      </QuickShopWithSiblings>
    );
  },
);
